import { atom, useAtom, useAtomValue } from "jotai";

export const perpLimitPriceAtom = atom<string>("");
export const perpLimitPriceNumAtom = atom((get) =>
  Number(get(perpLimitPriceAtom)),
);
export const updateTimeAtom = atom<number>(NaN);

export const usePerpLimitPrice = () => {
  const [perpLimitPrice, setPerpLimitPrice] = useAtom(perpLimitPriceAtom);
  const perpLimitPriceNum = useAtomValue(perpLimitPriceNumAtom);
  const [updateTime, setUpdateTime] = useAtom(updateTimeAtom);

  return {
    updateTime,
    perpLimitPrice,
    perpLimitPriceNum,
    setUpdateTime,
    setPerpLimitPrice,
  };
};
